import { PencilIcon } from "@heroicons/react/24/outline";
import { IconButton } from "../../../../../../../components/ui/IconButton";
import { Modal } from "../../../../../../../components/ui/Modal";
import AddEditDebtors from "./AddEditDebtors";

const Actions = props => {
  const { id, values, invoiceId } = props || {};

  const editModalProps = {
    body: AddEditDebtors,
    hideCloseButton: true,
    scale: "md",
    values,
    invoiceId,
  };

  if (typeof id == "number") {
    return (
      <div className="user-list-actions flex text-right text-sm font-medium">
        {id && (
          <div className="grid-cols-1 gap-4">
            <Modal {...editModalProps}>
              <IconButton variant="clean" title="Edit Debtors">
                <PencilIcon
                  className={`h-4 w-4 cursor-pointer text-gray-400`}
                />
              </IconButton>
            </Modal>
          </div>
        )}
      </div>
    );
  } else {
    return false;
  }
};

export default Actions;
